import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

// ── Query key factories ──

export const itemKeys = {
  all: ["items"] as const,
  list: (filters: { search?: string; status?: string }) => ["items", "list", filters] as const,
  detail: (id: string) => ["items", "detail", id] as const,
};

export const userKeys = {
  all: ["users"] as const,
  list: (filters?: { search?: string }) => ["users", "list", filters] as const,
} as const;

export const solutionKeys = {
  all: ["solutions"] as const,
  list: () => ["solutions", "list"] as const,
  detail: (id: string) => ["solutions", "detail", id] as const,
} as const;
